// extracted by mini-css-extract-plugin
module.exports = {"viewport":"TaskSVG_viewport__xI7_b","content":"TaskSVG_content__d5GE6","appear":"TaskSVG_appear__PfPtL"};